import faker from 'faker';

export default Array(10)
.fill(0)
.map((_, index) => ({  
    id: index,
    numero: faker.random.number({min:1000, max:5000}),
    status: 'Ativo',
    situacao: 'Vigente',
    fornecedor: faker.company.companyName()
}));

